export default __webpack_public_path__ + "static/media/Tapti-Ghat.b3609d18.jpg";